<template lang="pug">
.home
  .main-content
    .logo-pic
      img(src="../assets/images/didifunLogo.svg", alt="alt")
      .launch-text 零碳智慧租賃服務
      .launch-text Net Zero-carbon Rental Services

    .buttons(v-if="$root.runType === 'dev'")
      button.jump-btn(@click="startAction('register')")
        .btn-txt 開始旅程(預約)
      button.jump-btn.dev-btn(@click="startAction('member')")
        .btn-txt 開始旅程(用戶)
    .buttons(v-else)
      button.jump-btn(v-if="$root.member.user_lineId", @click="processStartAction")
        .btn-txt 開始旅程
      button.jump-btn(v-else)
        .btn-txt 等等哦
  //- .footer-txt DIDIFUN RENTAL SYSTEM
</template>
<script>
export default {
  name: "home",
  components: {},
  data () {
    return {};
  },
  mounted () {
  },
  methods: {
    startAction (_type) {
      this.$root.actionType = _type
      this.processStartAction()
    },
    processStartAction () {
      // 開始載入店家
      this.$root.loadStations()

      // 判斷需要前往的頁面 - 前往手機驗證
      if (!this.$root.member.user_phone) {
        this.$root.goPage('/phone-num')
        return
      }

      // 判斷需要前往的頁面 - 會員條碼
      if (this.$root.actionType === 'member') {
        this.$root.goPage('/member-center')
        return
      }

      // 判斷需要前往的頁面 - 會員預約
      if (this.$root.actionType === 'register') {
        this.$root.goPage('/reserve-select-main-type')
        return
      }
    }
  },
};
</script>
<style lang="sass" scoped>
.home
  height: 100%
  background-color: #22F48F
  .main-content
    width: 100%
    height: 100%
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    gap: 15vmin
    .logo-pic
      text-align: center
      img
        width: 53vmin
        vertical-align: middle
        margin-bottom: 15px
      .launch-text
        color: #000
        font-size: 5vmin
        font-weight: 700
    .jump-btn
      width: 53.75vmin
      border-radius: 12.5vmin
      background-color: #ffffff
      border: none
      padding: 2vmin 0px
      .btn-txt
        text-align: center
        font-size: 6vmin
        font-weight: 700
        color: #000000
    .dev-btn
      margin-top: 20px
  .buttons
    text-align: center

  .footer-txt
    width: 100%
    text-align: center
    position: fixed
    bottom: 4vmin
    font-size: 5vmin
    font-weight: 700
    color: #000
</style>
